module.exports = __webpack_public_path__ + "static/media/m_w_hb_12.9e68bd4f.png";